// removed by extract-text-webpack-plugin
module.exports = {"entry":"entry--R-NEB","titleset":"titleset--3OnUv","title":"title--1O4kp","logo":"logo--SnOMM","description":"description--3E69W","links":"links--3-teY"};